import { TimeRange } from '@mi-front/core';
import { MouseEvent as ReactMouseEvent, RefObject, useCallback } from 'react';
import { clientXToTs } from './client-x-to-ts';
import { useSetCursorAndPlay } from './useSetCursorAndMaybePlayOnClick';

/**
 * Click-to-seek across the focus tracks panel. Ignores clicks on buttons /
 * interactive controls (eye toggle, expand, appearance bars) so those keep
 * their own behaviour; empty lane space moves the playhead.
 */
export function useFocusTracksSeek(
  containerRef: RefObject<HTMLElement | null>,
  range: TimeRange<number>,
): (event: ReactMouseEvent) => void {
  const setCursorAndPlay = useSetCursorAndPlay();

  return useCallback(
    (event: ReactMouseEvent) => {
      const target = event.target as HTMLElement | null;
      if (target?.closest('button, [role="button"], a, input, textarea')) {
        return;
      }

      const container = containerRef.current;
      if (!container) {
        return;
      }

      setCursorAndPlay(clientXToTs(event.clientX, container.getBoundingClientRect(), range));
    },
    [containerRef, range, setCursorAndPlay],
  );
}
